import { useParams } from 'react-router';

import { useGetSchoolParticipantsImportsListQuery } from '@/api/endpoints/schools/schoolParticipants';
import { FetchDataWrapper } from '@/shared/components';

import { ParticipantsImport } from '../ParticipantsImport/ParticipantsImport';
import { ParticipantsImportHistory } from '../ParticipantsImportHistory/ParticipantsImportHistory';

import styles from './ImportSection.module.scss';

export const ImportSection = () => {
  const { id: schoolId } = useParams();
  const {
    data: importsData,
    isLoading: areImportsLoading,
    isError: isImportsDataFetchError,
  } = useGetSchoolParticipantsImportsListQuery({
    schoolId: Number(schoolId),
  });

  return (
    <FetchDataWrapper
      isLoading={areImportsLoading}
      isError={isImportsDataFetchError}
    >
      {importsData && (
        <div className={styles.wrapper}>
          <div className={styles['header-wrapper']}>
            <p className={styles.title}>Импорт участников</p>
            <p className={styles.description}>Загрузите файл с данными участников для массового импорта в систему</p>
          </div>
          <ParticipantsImport />
          <ParticipantsImportHistory importsData={importsData} />
        </div>
      )}
    </FetchDataWrapper>
  );
};
